export class EditLimitReachedError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'EditLimitReachedError';
    }
}
